<template>
    <ModalBase>
        <h1 class="title-modal">{{ $t("change.selectBrand") }}</h1>
        <swiper :options="swiperOption" ref="mySwiper" class="fd-r fw-w m-jc-sb">
            <swiper-slide>
                <div class="flexContainer logoContainer jc-c fd-r fw-w m-jc-sb">
                    <div class="brandWrap flexContainer jc-c size1of4" v-for="brand in brands" :key="brand.id">
                        <div class="brandLogo flexContainer" :class="brand.theme" @click="setCurrentBrand(brand)">
                            <img :src="`${brandImageUrl}${brand.imgPath}${brand.logo}`" class="imgBrand pointer" :alt="brand.name" />
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </ModalBase>
</template>

<script>
import ModalBase from "./ModalBase";
import Globals from "@/components/globals.js";
import { bus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import currentBrand from "@/services/currentBrand";
import cacheService from "@/services/cache";
import brandService from "@/services/brand";
import currentZone from "@/services/currentZone";

export default {
    name: "ModalBrand",
    data() {
        return {
            brands: [],
            currentZone: currentZone,
            brandImageUrl: Globals.getBaseUrl(),
            currentBrandId: cacheService.getCurrentBrandId(),
            swiperOption: {
                direction: "horizontal",
                loop: false,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: false,
                pagination: ".swiper-pagination",
                prevButton: ".swiper-button-prev",
                nextButton: ".swiper-button-next",
                paginationClickable: true,
                mousewheelControl: true,
                observeParents: true,
                debugger: true,
                slidesPerView: 1
            }
        };
    },
    components: { ModalBase },
    computed: {
        ...mapGetters("currentUser", { currentUser: "currentUser" })
    },
    methods: {
        ...mapActions("brand/", ["populate"]),
        ...mapActions("currentUser/", ["populateInfo"]),
        async setCurrentBrand(updatedBrand) {
            await currentBrand.save(updatedBrand, null, this.$accessUser, true);
            await currentZone.save(updatedBrand.zones[0], this.$accessUser);

            bus.$emit("closeModal", false);
            bus.$emit("resetOption", "null");
        }
    },
    created() {
        this.brands = brandService.getAll();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.logoContainer {
    .brandWrap {
        min-width: 100px;
        height: 95px;
        margin: 10px;
        .imgBrand {
            width: 100px;
            max-height: 90px;
            padding: 7px;
        }
    }
}
.swiper-container-horizontal {
    .swiper-pagination {
        margin-top: 10px;
        position: initial;
    }
}

.swiper-button-prev {
    left: 25%;
    height: 15px;
    display: none;
}

.swiper-button-next {
    right: 25%;
    height: 15px;
    display: none;
}
</style>



// WEBPACK FOOTER //
// ModalBrand.vue?59cda786